<template>
  <div class="py-6 px-8" id="user-index">
    <div class="mb-2">
      <h2 class="font-weight-medium-custom text-capitalize">
        Users & permissions
      </h2>
    </div>
    <div class="d-flex mt-8">
      <h2 class="font-weight-medium-custom mb-0 text-capitalize">Users</h2>
      <div v-if="!checkRole('accounts_read_only')" class="ml-auto d-flex">
        <v-btn
          dark
          class="font-weight-bold px-2"
          v-track="'add-user'"
          @click="addUser()"
        >
          <span class="pl-2 pr-3"> Invite </span>
        </v-btn>
      </div>
    </div>
    <v-data-table
      id="list-users-table"
      :headers="computedHeaders"
      fixed-header
      :items.sync="usersList"
      class="elevation-1 mt-5"
      :loading="loading"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :server-items-length.sync="totalItems"
      :options.sync="pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 25, 50, 100],
      }"
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.email`]="{ item }">
        <span class="body-1"> {{ item.email }}</span>
      </template>
      <template v-slot:[`item.permission`]="{ item }">
        <div>
          <span class="body-1">{{ item.permission }}</span>
          <span v-if="item.primary_contact"> (Primary Contact)</span>
        </div>
      </template>
      <template v-slot:[`item.access`]="{ item }">
        <span class="d-flex body-1">
          <span v-if="item.acesses.marketingimg" class="d-flex">
            <v-img
              src="@core/assets/images/logo_mmc.svg"
              max-width="18"
              class="d-flex mr-3"
            />
            <span class="body-1">Marketing</span>
          </span>
          <span
            v-if="item.acesses.marketingimg && item.acesses.servicesimg"
            class="ml-2 mr-2 grey--text"
            >|</span
          >
          <span v-if="item.acesses.servicesimg" class="d-flex">
            <v-img
              src="@core/assets/images/logo_msc.svg"
              max-width="18"
              class="d-flex mr-3"
            />
            <span class="body-1">Service</span>
          </span>
        </span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <div
          class="d-flex align-center"
          v-if="
            item.email !== $store.state.auth.userdata.email &&
            item.email !== owner.email &&
            !checkRole('accounts_read_only')
          "
        >
          <span @click.stop class="body-1">
            <v-menu left bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon
                  v-track="'user-action-menu'">
                  <v-icon class="font-weight-bold">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense class="pa-0">
                <v-list-item-group>
                  <v-list-item
                    id="edit-type"
                    link
                    @click="userAction(item, 'edit')"
                    v-track="'edit-action'"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Edit</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="userAction(item, 'duplicate')"
                    class="manage-user-duplicate-action"
                    v-track="'duplicate-user'"
                  >
                    <v-icon class="mr-2 title"> mdi-file </v-icon>
                    <v-list-item-title class="body-1 font-weight-regular">
                      Duplicate
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="resendInvite(item)"
                    class="manage-user-duplicate-action"
                    v-track="'duplicate-user'"
                  >
                    <v-icon class="mr-2 title"> mdi-account-reactivate </v-icon>
                    <v-list-item-title class="body-1 font-weight-regular">
                      Resend Invite
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    id="delete-type"
                    link
                    @click="userAction(item, 'delete')"
                    v-track="'delete-action'"
                  >
                    <v-list-item-icon class="mr-1">
                      <v-icon size="20">mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-regular"
                        >Delete</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </span>
        </div>
      </template>
    </v-data-table>

    <v-navigation-drawer
      v-model="userAddEditDrawer"
      class="px-6 pt-6 overflow-y-hidden pr-2 groups"
      id="add-edit-user-drawer"
      width="550px"
      fixed
      right
      temporary
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left">
            <h2
              class="
                secondary--font
                font-weight-medium-custom
                float-left
                text-capitalize
              "
            >
              {{ action }} User
            </h2>
          </v-col>
          <v-col align="right">
            <v-btn
              icon
              @click.stop="userAddEditDrawer = false"
              class="float-right"
              v-track="'show-hide-user-drawer'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12 py-2 pt-5">
            <span v-if="action == 'invite'">
              Invite new user with below details.
            </span>
            <span v-else> Edit user details below . </span>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font"> Delete User </span>
        </v-card-title>
        <v-card-text class="body-2">
          Are you sure you want to delete this user?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false" 
            v-track="'cancel-delete-dialog'"
            class="font-weight-bold">
            Cancel
          </v-btn>
          <v-btn
            dark
            @click="deleteUser()"
            v-track="'delete-user'"
            class="font-weight-bold"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { $invitations, $users } from "@core/services";
import { mapGetters } from "vuex";

export default {
  name: "create-update-user",
  data() {
    return {
      accountId: "",
      deleteDialog: false,
      userAddEditDrawer: false,
      itemsPerPage: 10,
      invitationId: "",
      primaryContact: true,
      usersList: [],
      action: "invite",
      access: false,
      rules: {
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address.",
        ],
      },
      headers: [
        {
          text: "Email",
          align: "start",
          value: "email",
          width: "40%",
          sortable: false,
          class: "body-2",
        },
        {
          text: "Access",
          value: "access",
          width: "30%",
          sortable: false,
          class: "body-2",
        },
        {
          text: " Role",
          value: "permission",
          width: "20%",
          sortable: false,
          class: "body-2",
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          class: "body-2",
        },
      ],
      totalItems: 0,
      pagination: { sortDesc: [true] },
      searchString: "",
      hasPrimaryContact: false,
      loading: false,
      page: 1,
      isAdminSelected: false,
      owner: {},
    };
  },

  computed: {
    computedHeaders() {
      return this.headers.filter((header, index) => {
        return header.show === undefined || header.show;
      });
    },
    ...mapGetters({
      checkRole: "auth/checkRole",
      currentAccount: "auth/account.current",
    }),
  },
  watch: {
    "$store.state.ui.drawer.right.response": function () {
      if (
        this.$store.getters["ui/drawer"].right.response.checkUserUpdateInfo ||
        this.$store.getters["ui/drawer"].right.response.hasPrimaryContact
      ) {
        this.getUsersData();
      }
    },
    "$store.state.ui.drawer.right.show": function () {
      if (!this.$store.getters["ui/drawer"].right.show) {
        this.getUsersData();
      }
    },
    pagination: {
      handler() {
        this.getUsersData();
      },
      deep: true,
    },
    $route(to, from) {
      this.searchString = to.query.name;
      this.pagination.page = 1;
      this.page = 1;
      this.getUsersData();
    },
  },

  mounted() {
    let userIndexElement = document.querySelector("#user-index");
    if (userIndexElement) {
      userIndexElement.parentElement.classList.remove("px-8", "container");
      userIndexElement.parentElement.parentElement.classList.remove("pt-2");
    }
    $users
      .getRoles()
      .then((response) => {
        this.$store.commit("auth/roles", response.data.data.roles);
      })
      .catch((error) => {
        console.log("error", error);
      });
    this.searchString = this.$route.query.name ? this.$route.query.name : "";
    if (this.$store.state.auth.editAccountId) {
      this.accountId = this.$store.state.auth.editAccountId;
    } else {
      this.accountId = this.$store.state.auth.account.id;
    }
    if (this.checkRole("accounts_read_only")) {
      this.headers[3].text = "";
    }
  },
  methods: {
    addUser() {
      this.$store.commit("ui/drawer.right", {
        show: true,
        component: "user-drawer",
        response: {
          checkUserUpdateInfo: false,
          userAction: "create",
        },
      });
    },
    resendInvite(user){
      $invitations
        .resendInvite( this.currentAccount.uid, user.id).then(res=>{
          this.$store.commit("ui/snackbar", {
            message: res.data.message,
            type: "success",
          });
        },err=>{
          this.$store.commit("ui/snackbar", {
              message: err.response.data.message,
              type: "error",
            });
        })
    },
    userAction(item, action) {
      $invitations
        .fetch({
          params: {
            user_email: item.email,
          },
        })
        .then((response) => {
          if (!response.data.data.invitations.length) {
            this.$store.commit("ui/snackbar", {
              message: "User details not found.",
              type: "error",
            });
            return;
          }

          this.invitationId = response.data.data.invitations[0].id;
          switch (action) {
            case "edit":
              this.editUser(item);
              break;
            case "duplicate":
              this.duplicateUser(item);
              break;
            case "delete":
              this.deleteDialog = true;
              break;
          }
        })
        .catch((err) => {
          this.$store.commit("ui/snackbar", {
            message: "Failed to fetch user's info",
            type: "error",
          });
        });
    },
    editUser(item) {
      this.$store.commit("ui/drawer.right", {
        show: true,
        component: "user-drawer",
        response: {
          checkUserUpdateInfo: false,
          userAction: "edit",
          invitationId: this.invitationId,
          isPrimary: item.primary_contact,
          hasPrimaryContact: this.hasPrimaryContact,
        },
      });
    },
    duplicateUser(item) {
      this.$store.commit("ui/drawer.right", {
        show: true,
        component: "user-drawer",
        response: {
          checkUserUpdateInfo: false,
          userAction: "duplicate",
          invitationId: this.invitationId,
          hasPrimaryContact: this.hasPrimaryContact,
        },
      });
    },
    deleteUserModal(item) {
      this.invitationId = item.id;
      this.deleteDialog = true;
    },
    closeDeleteUserModal() {
      this.deleteDialog = false;
      this.invitationId = "";
    },
    deleteUser() {
      this.loading = true;
      $invitations
        .delete(this.invitationId)
        .then((response) => {
          this.$store.commit("ui/snackbar", {
            message: response.data.message,
            type: "success",
          });
          this.closeDeleteUserModal();
          this.getUsersData();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getUsersData() {
      this.loading = true;
      const data = {
        page: this.pagination.page || this.page,
        per_page: this.pagination.itemsPerPage || this.itemsPerPage,
      };

      this.searchString = this.$route.query.name ? this.$route.query.name : "";
      if (this.searchString) {
        data.email_cont = this.searchString;
      }

      $invitations
        .fetchMembers(this.currentAccount.uid, {
          params: data,
        })
        .then((response) => {
          this.usersList = response.data.data || [];
          this.totalItems = response.data.meta.total;
          this.hasPrimaryContact = false;
          var iterator = 0;
          for (let i of this.usersList) {
            this.usersList[iterator].permission = "User";
            if (i.primary_contact) {
              this.hasPrimaryContact = true;
            }
            this.usersList[iterator].acesses = {
              servicesimg: false,
              marketingimg: false,
            };
            for (let item of i.roles) {
              if (item.includes("service/") && this.currentAccount.enable_service) {
                this.usersList[iterator].acesses.servicesimg = true;
              }
              if (
                (!item.includes("service/") &&
                item != "account" &&
                item != "accounts_read_only") && this.currentAccount.enable_marketing 
              ) {
                this.usersList[iterator].acesses.marketingimg = true;
              }
            }
            iterator += 1;
          }
          let userData = this.usersList;
          userData.forEach(function (item, i) {
            if (item.primary_contact == true) {
              userData.splice(i, 1);
              userData.unshift(item);
            }
          });

          $invitations
            .getOwnerData()
            .then((response) => {
              if (this.usersList.length && this.usersList[0].permission === "Admin") return;
              if (this.pagination.page === 1) {
                this.owner = response.data.owner;
                this.owner.acesses = {
                  servicesimg: false,
                  marketingimg: false,
                };
                this.owner.permission = "Admin";
                this.owner.role = "Admin";
                this.currentAccount.enable_service == true
                  ? (this.owner.acesses.servicesimg = true)
                  : (this.owner.acesses.servicesimg = false);
                this.currentAccount.enable_marketing == true
                  ? (this.owner.acesses.marketingimg = true)
                  : (this.owner.acesses.marketingimg = false);
                this.usersList.splice(0, 0, this.owner);
                this.isBodySlotEnabled = true;
                if (this.usersList.length <= 1) {
                  this.totalItems = this.totalItems === 0 ? 1 : this.totalItems;
                }
              } else {
                this.isBodySlotEnabled = false;
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.v-image__image--cover {
  background-size: contain !important;
}
</style>
